import { Theme } from '@/styles/Theme';

export type MonthlyBillStatus = 'pending' | 'sent' | 'pending_confirmation' | 'paid' | 'overdue' | 'failed' | 'rejected';

/**
 * Monthly Bill Status Label Mapping
 */
export const MONTHLY_BILL_STATUS_LABEL: Record<MonthlyBillStatus, string> = {
  pending: '대기중',
  sent: '발송됨',
  pending_confirmation: '확인 대기',
  paid: '결제완료',
  overdue: '연체',
  failed: '실패',
  rejected: '거부',
};

/**
 * Monthly Bill Status Color Mapping
 */
export const MONTHLY_BILL_STATUS_COLOR: Record<MonthlyBillStatus, string> = {
  pending: Theme.colors.G_1,
  sent: Theme.colors.B_3,
  pending_confirmation: '#FF9800', // Orange
  paid: Theme.colors.GREEN,
  overdue: Theme.colors.WARNING_RED,
  failed: Theme.colors.WARNING_RED,
  rejected: Theme.colors.G_1,
};

/**
 * Get Korean label for monthly bill status
 */
export const getMonthlyBillStatusLabel = (status: MonthlyBillStatus | string): string => {
  return MONTHLY_BILL_STATUS_LABEL[status as MonthlyBillStatus] || status;
};

/**
 * Get color for monthly bill status
 */
export const getMonthlyBillStatusColor = (status: MonthlyBillStatus | string): string => {
  return MONTHLY_BILL_STATUS_COLOR[status as MonthlyBillStatus] || Theme.colors.BLACK;
};

/**
 * Get status badge info (label + color)
 */
export const getMonthlyBillStatusBadge = (status: MonthlyBillStatus | string): { text: string; color: string } => {
  return {
    text: getMonthlyBillStatusLabel(status),
    color: getMonthlyBillStatusColor(status),
  };
};
